import { JobStatus, Report } from '@/api/generatedApi';
import { FailureWhyButton } from '@/components/FailureDiagnostics/FailureWhyButton';
import { REPORT_TITLES } from '@/components/Report/consts';
import { StatusBadge } from '@/components/StatusBadge';
import { useReportPolling } from '@/hooks/useDataPolling/useReportPolling';
import { Box } from '@mui/material';

export const ReportStatusCell = ({ row }: { row: Report }) => {
  const { data: report } = useReportPolling({ row });

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', height: '100%' }}>
      <StatusBadge status={report.status} progress={report.progress} />
      {report.status === JobStatus.FAILED && (
        <FailureWhyButton
          assetId={report.id}
          assetName={report.name || REPORT_TITLES[report.reportType]}
          kind='report'
        />
      )}
    </Box>
  );
};
